import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { incidentsApi } from '@/api/index';
import type {
  IncidentsAggregateCarBody,
  IncidentsAggregateTimeBody,
  IncidentsFullBody,
} from '@/api/routes/incidents/types';

export const fetchIncidentsFull = createAsyncThunk(
  'incidents/full',
  async (params: IncidentsFullBody, thunkAPI) => {
    try {
      const response = await incidentsApi.getFullIncidents(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchIncidentsAggregateTime = createAsyncThunk(
  'incidents/aggregate-time',
  async (params: IncidentsAggregateTimeBody, thunkAPI) => {
    try {
      const response = await incidentsApi.getAggregatedIncidentsTime(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchIncidentsAggregateCar = createAsyncThunk(
  'incidents/aggregate-car',
  async (params: IncidentsAggregateCarBody, thunkAPI) => {
    try {
      const response = await incidentsApi.getAggregatedIncidentsCar(params);
      return response ? response.data : {};
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
